import { type GetAdditionalObjectsRequest } from './integrations'

export type RawWorkflowLists<W> = {
  workflows?: W[]
  completedWorkflows?: W[]
}

export interface WorkflowListsCacheKey {
  accountId: string
  connector: string
  externalId: string
}

export const workflowListsRequest = ({ accountId, connector, externalId }: WorkflowListsCacheKey): GetAdditionalObjectsRequest => ({
  accountId,
  connector,
  relatedTo: { id: externalId },
  includeWorkflows: true,
  includeWorkflowTemplates: true,
})

export const withUpsertedWorkflow = <W extends { id: number; completedAt?: string | null }>(lists: RawWorkflowLists<W>, workflow: W): RawWorkflowLists<W> => {
  const running = (lists.workflows ?? []).filter((existing) => existing.id !== workflow.id)
  const completed = (lists.completedWorkflows ?? []).filter((existing) => existing.id !== workflow.id)
  if (workflow.completedAt) {
    return { workflows: running, completedWorkflows: [workflow, ...completed] }
  }
  const index = (lists.workflows ?? []).findIndex((existing) => existing.id === workflow.id)
  const workflows = index === -1 ? [...running, workflow] : (lists.workflows ?? []).map((existing) => (existing.id === workflow.id ? workflow : existing))
  return { workflows, completedWorkflows: completed }
}
